import { render, staticRenderFns } from "./FbDelimiter.vue?vue&type=template&id=bb64225c&scoped=true"
import script from "./FbDelimiter.vue?vue&type=script&lang=js"
export * from "./FbDelimiter.vue?vue&type=script&lang=js"
import style0 from "./FbDelimiter.vue?vue&type=style&index=0&id=bb64225c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb64225c",
  null
  
)

export default component.exports